/**
 * Browser-side half of the supervisor join contract.
 *
 * Mirrors `src/common/types/supervisor.type.ts` in call-agent-api and
 * call-agent-campaign-worker. The web app is a participant in the room, so it reads the
 * agent's acknowledgements straight off the agent's participant rather than through the
 * API - one fewer round-trip and no stale reads.
 */

export const SUPERVISOR_ATTRIBUTE = {
  ROLE: 'ca.participant.role',
  MODE: 'ca.supervisor.mode',
  AGENT_SIGNAL_ACK: 'ca.agent.signal.ack',
  AGENT_SILENCED: 'ca.agent.silenced',
} as const;

export const SUPERVISOR_SIGNAL_TOPIC = 'ca.supervisor.signal';

export const SUPERVISOR_MODE = {
  LISTEN: 'listen',
  BARGE: 'barge',
} as const;

export type SupervisorMode = (typeof SUPERVISOR_MODE)[keyof typeof SUPERVISOR_MODE];

/** How long to wait for the agent before declaring the handshake failed. */
export const SUPERVISOR_TIMEOUTS = {
  /** Signal is a liveness probe - a slow answer is already a failed answer. */
  SIGNAL_ACK_MS: 5000,
  /**
   * The customer is waiting in silence while this runs, so it cannot be generous.
   * On expiry the operator gets an explicit failure, never a silently open mic.
   */
  AGENT_SILENCE_MS: 5000,
} as const;
